// icons
import "boxicons/css/boxicons.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import { createApp } from "vue";
import App from "./App.vue";
import Default from "./Default.vue";
import Login from "./Login.vue";
import Error from "./Error.vue";
//import router
import router from "./routers";

//import Bootstrap, Popper, jQuery
// import 'bootstrap/dist/css/bootstrap.css'
// import 'jquery/dist/jquery.min'
// import 'popper.js/dist/popper.min'
// import 'bootstrap/dist/js/bootstrap.min'
import VueApexCharts from "vue3-apexcharts";
import Toaster from "@meforma/vue-toaster";
import VueBarcode from "@chenfengyuan/vue-barcode";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";

import "@brayan/ui/styles/global.css";

const app = createApp(App);

if (process.env.NODE_ENV === "development") {
  app.config.globalProperties.globalApiUrl = "http://localhost:8000/";
} else {
  app.config.globalProperties.globalApiUrl = process.env.VUE_APP_API_URL;
}

// app.config.globalProperties.globalApiUrl = "http://192.168.18.241:8800/";
// app.config.globalProperties.globalApiUrl = "https://brayandiesel.com/";
app.component("app-layout", Default);
app.component("login-layout", Login);
app.component("error-layout", Error);
app.component("v-select", vSelect);
app.use(VueApexCharts);
app.component(VueBarcode.name, VueBarcode);
app.use(Toaster);
app.use(VueViewer);
//use vue router
app.use(router);

app.mount("#app");
